module.exports = __webpack_public_path__ + "img/landwirt.8762b6df.png";